import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SetprofilodivisorioService {


  constructor() { }
  getLunghezze() {
    return [80,120,160,200,240,280,320];
  }

  getData() {
  return  [
      { "art_comp": "MS042103", "desc": "SET PROF.DIV.N/MOD.S.6 B. 80",  "spessore": 6,  "lunghezza": 80,  "finitura": "STANDARD" },
      { "art_comp": "MS042104", "desc": "SET PROF.DIV.N/MOD.S.6 B. 120", "spessore": 6,  "lunghezza": 120, "finitura": "STANDARD" },
      { "art_comp": "MS042105", "desc": "SET PROF.DIV.N/MOD.S.6 B. 160", "spessore": 6,  "lunghezza": 160, "finitura": "STANDARD" },
      { "art_comp": "MS042106", "desc": "SET PROF.DIV.N/MOD.S.6 B. 200", "spessore": 6,  "lunghezza": 200, "finitura": "STANDARD" },
      { "art_comp": "MS042107", "desc": "SET PROF.DIV.N/MOD.S.6 B. 240", "spessore": 6,  "lunghezza": 240, "finitura": "STANDARD" },
      { "art_comp": "MS042108", "desc": "SET PROF.DIV.N/MOD.S.6 B. 280", "spessore": 6,  "lunghezza": 280, "finitura": "STANDARD" },
      { "art_comp": "MS042109", "desc": "SET PROF.DIV.N/MOD.S.6 B. 320", "spessore": 6,  "lunghezza": 320, "finitura": "STANDARD" },

      { "art_comp": "MS042444", "desc": "SET PROF.DIV.N/MOD.S.6 G. 80",  "spessore": 6,  "lunghezza": 80,  "finitura": "INOX" },
      { "art_comp": "MS042445", "desc": "SET PROF.DIV.N/MOD.S.6 G. 120", "spessore": 6,  "lunghezza": 120, "finitura": "INOX" },
      { "art_comp": "MS042446", "desc": "SET PROF.DIV.N/MOD.S.6 G. 160", "spessore": 6,  "lunghezza": 160, "finitura": "INOX" },
      { "art_comp": "MS042447", "desc": "SET PROF.DIV.N/MOD.S.6 G. 200", "spessore": 6,  "lunghezza": 200, "finitura": "INOX" },
      { "art_comp": "MS042448", "desc": "SET PROF.DIV.N/MOD.S.6 G. 240", "spessore": 6,  "lunghezza": 240, "finitura": "INOX" },
      { "art_comp": "MS042449", "desc": "SET PROF.DIV.N/MOD.S.6 G. 280", "spessore": 6,  "lunghezza": 280, "finitura": "INOX" },
      { "art_comp": "MS042450", "desc": "SET PROF.DIV.N/MOD.S.6 G. 320", "spessore": 6,  "lunghezza": 320, "finitura": "INOX" },

      { "art_comp": "MS046624", "desc": "SET PROF.DIV.N/MOD.S10 B. 80",  "spessore": 10, "lunghezza": 80,  "finitura": "STANDARD" },
      { "art_comp": "MS046625", "desc": "SET PROF.DIV.N/MOD.S10 B. 120", "spessore": 10, "lunghezza": 120, "finitura": "STANDARD" },
      { "art_comp": "MS046626", "desc": "SET PROF.DIV.N/MOD.S10 B. 160", "spessore": 10, "lunghezza": 160, "finitura": "STANDARD" },
      { "art_comp": "MS046627", "desc": "SET PROF.DIV.N/MOD.S10 B. 200", "spessore": 10, "lunghezza": 200, "finitura": "STANDARD" },
      { "art_comp": "MS046628", "desc": "SET PROF.DIV.N/MOD.S10 B. 240", "spessore": 10, "lunghezza": 240, "finitura": "STANDARD" },
      { "art_comp": "MS046629", "desc": "SET PROF.DIV.N/MOD.S10 B. 280", "spessore": 10, "lunghezza": 280, "finitura": "STANDARD" },
      { "art_comp": "MS046630", "desc": "SET PROF.DIV.N/MOD.S10 B. 320", "spessore": 10, "lunghezza": 320, "finitura": "STANDARD" },

      { "art_comp": "MS046781", "desc": "SET PROF.DIV.N/MOD.S10 G. 80",  "spessore": 10, "lunghezza": 80,  "finitura": "INOX" },
      { "art_comp": "MS046782", "desc": "SET PROF.DIV.N/MOD.S10 G. 120", "spessore": 10, "lunghezza": 120, "finitura": "INOX" },
      { "art_comp": "MS046783", "desc": "SET PROF.DIV.N/MOD.S10 G. 160", "spessore": 10, "lunghezza": 160, "finitura": "INOX" },
      { "art_comp": "MS046784", "desc": "SET PROF.DIV.N/MOD.S10 G. 200", "spessore": 10, "lunghezza": 200, "finitura": "INOX" },
      { "art_comp": "MS046785", "desc": "SET PROF.DIV.N/MOD.S10 G. 240", "spessore": 10, "lunghezza": 240, "finitura": "INOX" },
      { "art_comp": "MS046786", "desc": "SET PROF.DIV.N/MOD.S10 G. 280", "spessore": 10, "lunghezza": 280, "finitura": "INOX" },
      { "art_comp": "MS046787", "desc": "SET PROF.DIV.N/MOD.S10 G. 320", "spessore": 10, "lunghezza": 320, "finitura": "INOX" }
    ];

   }
}
